module.exports = __webpack_public_path__ + "img/addBookcase.f4599d1e.svg";